import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import store from "/redux/state";
import AuthContext from "/context/AuthProvider";

const DelayLink = ({
  children,
  to,
  need_auth = false,
  cd = undefined,
  myRef = null,
  ...props
}) => {
  function navigate(to, { replace = false } = {}) {
    if (replace) {
      window.history.replaceState({}, "", to);
    } else {
      window.history.pushState({}, "", to);
    }
  }
  const { auth } = useContext(AuthContext);

  // const handleClick = (e) => {
  //   cd && cd(e);
  //   if (location?.pathname === to) return;
  //   if (e.defaultPrevented || props?.target == "_blank") return;

  //   e.preventDefault();

  //   if (need_auth && !auth.token) {
  //     store.setPopUp("login");
  //     return;
  //   }

  //   if (props?.disabled) return;
  //   navigate(to);
  // };

  return to ? (
    <a href={to} {...props} ref={myRef} target="_blank">
      {children}
    </a>
  ) : (
    <div {...props}>{children}</div>
  );
};

export default DelayLink;
